module.exports = __webpack_public_path__ + "b5a0a0df312d3423493b163e9675488c.woff";